// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__284Gj","wrapper":"Link_wrapper__2oZ8p","disabled":"Link_disabled__3Rj0_"};